import React, { useState, useEffect } from "react";
import { BlackAndWhite } from "../../../../themes/Colors";
import {
  CustomerTicketsDisplayPanel,
  PrescriptionTicketsDisplayPanel,
  SystemTicketsDisplayPanel,
  TopTabController,
} from "./components";

const PosSupportDisplay = ({
  user,
  setLoading,
  height,
  width,
  setToastPop,
  setMessage,
}) => {
  const [refresh, setRefresh] = useState(false);

  const [selectedDisplay, setSelectedDisplay] = useState("customer");
  const [filterState, setFilterState] = useState("PENDING");
  const [supportTickectsArrayCustomers, setSupportTickectsArrayCustomers] =
    useState(null);
  const [supportTickectsArrayBugs, setSupportTickectsArrayBugs] =
    useState(null);
  const [
    supportTickectsArrayPrescription,
    setSupportTickectsArrayPrescription,
  ] = useState(null);

  const GetSupportPrescriptionTickets = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/support/getSupportTicketbyType",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.adminUserData.userId,
            type: "PRESCRITION",
          }),
        }
      );

      const respnseData = await response.json();

      if (!respnseData.error) {
        setSupportTickectsArrayPrescription(respnseData.data);
        setLoading(false);
        // setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const GetSupportCustomerTickets = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/support/getSupportTicketbyType",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.adminUserData.userId,
            type: "CUSTOMER",
          }),
        }
      );

      const respnseData = await response.json();

      if (!respnseData.error) {
        setSupportTickectsArrayCustomers(respnseData.data);
        setLoading(false);
        // setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  const GetSupportSystemBugTickets = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/support/getSupportTicketbyType",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: user.adminUserData.userId,
            type: "SYSTEM",
          }),
        }
      );

      const respnseData = await response.json();

      if (!respnseData.error) {
        setSupportTickectsArrayBugs(respnseData.data);
        setLoading(false);
        // setLoading(false);
      }
    } catch (err) {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (user) {
      GetSupportSystemBugTickets();
      GetSupportCustomerTickets();
      GetSupportPrescriptionTickets();
    }
  }, [refresh]);
  return (
    <div
      style={{
        backgroundColor: "#00000010",
        height: height,
        position: "relative",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        overflow: "hidden",
        width: "100%",
      }}
    >
      <TopTabController
        selectedDisplay={selectedDisplay}
        setSelectedDisplay={setSelectedDisplay}
        setFilterState={setFilterState}
      />
      {selectedDisplay === "customer" ? (
        <CustomerTicketsDisplayPanel
          filterState={filterState}
          tickets={supportTickectsArrayCustomers}
          user={user}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          setLoading={setLoading}
        />
      ) : null}
      {selectedDisplay === "bugs" ? (
        <SystemTicketsDisplayPanel
          filterState={filterState}
          tickets={supportTickectsArrayBugs}
          user={user}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          setLoading={setLoading}
        />
      ) : null}
      {selectedDisplay === "prescriptions" ? (
        <PrescriptionTicketsDisplayPanel
          filterState={filterState}
          tickets={supportTickectsArrayPrescription}
          user={user}
          setMessage={setMessage}
          setToastPop={setToastPop}
          setRefresh={setRefresh}
          refresh={refresh}
          setLoading={setLoading}
        />
      ) : null}
    </div>
  );
};
export default PosSupportDisplay;
